import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError, formatCDF } from "../../lib/api";
import AdminShell from "../../components/AdminShell";
import { Card, Button, Input, Label } from "../../components/ui-kit";

export default function AdminPricing() {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/pricing");
      setRules(data);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const save = async (rule) => {
    try {
      await api.put(`/admin/pricing/${rule.vehicle_type}`, {
        base_fare: Number(rule.base_fare),
        per_km: Number(rule.per_km),
        per_min: Number(rule.per_min),
        min_fare: Number(rule.min_fare),
        cancellation_fee: Number(rule.cancellation_fee),
        waiting_fee_per_min: Number(rule.waiting_fee_per_min),
      });
      toast.success(`Tarifs ${rule.vehicle_type} sauvegardés`);
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  const updateField = (idx, key, value) => {
    const copy = [...rules];
    copy[idx] = { ...copy[idx], [key]: value };
    setRules(copy);
  };

  const fields = [
    { key: "base_fare", label: "Tarif de base" },
    { key: "per_km", label: "Par km" },
    { key: "per_min", label: "Par minute" },
    { key: "min_fare", label: "Minimum course" },
    { key: "cancellation_fee", label: "Frais annulation" },
    { key: "waiting_fee_per_min", label: "Attente/min" },
  ];

  return (
    <AdminShell title="Tarifs">
      <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tighter">Moteur tarifaire</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        Prix final = base + distance × tarif_km + durée × tarif_min + supplément_zone, × majoration_pointe (min fare appliqué).
      </p>

      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        {loading && <div className="text-sm font-bold uppercase tracking-widest">Chargement…</div>}
        {rules.map((r, idx) => (
          <Card key={r.vehicle_type} className="p-5" data-testid={`pricing-${r.vehicle_type}`}>
            <div className="flex items-center justify-between">
              <div className="font-heading text-2xl font-black tracking-tighter uppercase">
                {r.vehicle_type === "moto" ? "Moto" : "Voiture"}
              </div>
              <div className="border-2 border-foreground bg-primary px-2 py-1 text-[10px] font-black uppercase tracking-widest text-primary-foreground">
                CDF
              </div>
            </div>

            <div className="mt-4 grid grid-cols-2 gap-3">
              {fields.map((f) => (
                <div key={f.key}>
                  <Label>{f.label}</Label>
                  <Input
                    type="number"
                    value={r[f.key]}
                    onChange={(e) => updateField(idx, f.key, e.target.value)}
                    data-testid={`pricing-${r.vehicle_type}-${f.key}`}
                  />
                </div>
              ))}
            </div>

            <Button
              variant="primary"
              className="mt-4 w-full"
              onClick={() => save(r)}
              data-testid={`save-pricing-${r.vehicle_type}`}
            >
              Sauvegarder
            </Button>
          </Card>
        ))}
      </div>
    </AdminShell>
  );
}
